import { render, staticRenderFns } from "./TourDetailsExcursion.vue?vue&type=template&id=62bb847a&scoped=true"
import script from "./TourDetailsExcursion.vue?vue&type=script&lang=js"
export * from "./TourDetailsExcursion.vue?vue&type=script&lang=js"
import style0 from "./TourDetailsExcursion.vue?vue&type=style&index=0&id=62bb847a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62bb847a",
  null
  
)

export default component.exports